import script from "./ImportantChangesDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImportantChangesDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ImportantChangesDialog.vue?vue&type=style&index=0&id=37069571&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37069571"]])

export default __exports__